<template>
  <li
    v-if="customsChargeItem"
    class="cart-summary-list__item"
  >
    {{ label }}
    <span class="font-bold">{{ amount }}</span>
  </li>
</template>

<script>
import { useCartStore } from '../../pinia/CartStore'
import { mapState } from 'pinia'
import { productPrice } from '../../helpers/product'

export default {
  name: 'CustomsChargeSummaryRow',
  computed: {
    ...mapState(useCartStore, [
      'customsChargeItem',
      'customsChargeLinePrice',
    ]),
    label () {
      return window.theme.cart.customsCharge.strings.summaryLabel
    },
    amount () {
      return productPrice(this.customsChargeLinePrice)
    },
  },
}
</script>
